let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("b1rV4")]).then(() => parcelRequire('9E32x'));